import { QueryConfig, useQuery } from "react-query";
import { fetchJSON } from "../../lib/fetch";
import config from "../../site-config";
import { ILinearProgressClasses } from "./components/linear-progress";
import React, { FC, useEffect, useState } from "react";
import Player3D from "./player-3d";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import classNames from "classnames";
import { DATATEST } from "../../constants/integration";

interface IResponse {
    status: string;
    model: any;
}

interface IAsync3DProps {
    threediumId: string;
    distanceFactor?: number;
    onClick?: () => void;
    disableRendering?: boolean;
    classes?: {
        statusMessage?: string;
        iframe?: string;
        wrapper?: string;
        hint?: string;
        progressWrapper?: string;
        progressClasses?: ILinearProgressClasses;
    };
    useFitToView?: boolean;
}
export const GET_PRODUCT_MODEL = "GET_PRODUCT_MODEL";

const useProduct3DModel = (threediumId: string, options?: QueryConfig<IResponse>) => {
    return useQuery<IResponse>(
        [GET_PRODUCT_MODEL, threediumId],
        () =>
            fetchJSON<IResponse>(`${config.api}/api/v3.0/threedium/${threediumId}`, {
                method: "GET",
                headers: {},
            }).then((r) => r),
        options
    );
};

const useStyles = makeStyles<Theme>({
    noResults: {
        top: "50%",
        margin: "-60px",
        position: "relative",
        left: "50%",
        fontSize: "16px",
    },
});

export const Async3DPlayerWrapper: FC<IAsync3DProps> = (props: IAsync3DProps) => {
    const { onClick, threediumId, classes } = props;
    const c = useStyles();
    const [threediumAsset, setThreediumAsset] = useState<any>(null);
    const { data, isFetching } = useProduct3DModel(threediumId, { enabled: true });

    useEffect(() => {
        if (isFetching) {
            setThreediumAsset(null);
        }
        if (!isFetching && data) {
            const asset = {
                status: data.status,
                distID: "",
                solution3DID: "",
                projectName: "",
                version: "",
                solution3DName: "",
            };

            if (data.model?.distribution) {
                asset.distID = data.model.distribution.dist;
                asset.solution3DID = data.model.solutionId;
                asset.projectName = data.model.distribution.projectName;
                asset.version = data.model.distribution.libVersion;
                asset.solution3DName = data.model.distribution.solutionName;
            }
            setThreediumAsset(asset);
        }
    }, [data, isFetching, threediumId]);

    return (
        <span>
            {threediumAsset && threediumAsset.status == "processing" && (
                <span
                    data-test={DATATEST.PLAYER_3D.PROCESSING_CONTAINER}
                    className={classNames(c.noResults, props.classes?.statusMessage)}
                >
                    Model is processing
                </span>
            )}
            {threediumAsset && threediumAsset.status == "failed" && (
                <span
                    data-test={DATATEST.PLAYER_3D.PROCESSING_CONTAINER}
                    className={classNames(c.noResults, props.classes?.statusMessage)}
                >
                    Can't process model
                </span>
            )}
            {threediumAsset && threediumAsset.distID != "" && (
                <Player3D
                    useFitToView={props.useFitToView}
                    distanceFactor={props.distanceFactor}
                    disableRendering={props.disableRendering}
                    classes={classes}
                    key={threediumAsset.distID}
                    template={threediumAsset}
                    version={threediumAsset.version}
                    onClick={onClick}
                />
            )}
        </span>
    );
};
